import { FormHelperText } from '@mui/material';
import { FormikProps, getIn } from 'formik';
import React from 'react';

interface Props {
  name: string;
  helperText?: string;
}

export default function FormikHelperText<T>(props: Props & FormikProps<T>) {
  const { helperText, name, errors, touched } = props;
  const error = !!getIn(errors, name) && !!getIn(touched, name);
  const text = !!error ? getIn(errors, name) : helperText || ' ';

  return <FormHelperText error={error}>{text}</FormHelperText>;
}
